import { render, staticRenderFns } from "./popups.vue?vue&type=template&id=60696075&scoped=true&"
import script from "./popups.vue?vue&type=script&lang=js&"
export * from "./popups.vue?vue&type=script&lang=js&"
import style0 from "./popups.vue?vue&type=style&index=0&id=60696075&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60696075",
  null
  
)

export default component.exports